import { type FunctionComponent } from 'react'
import * as React from 'react'
import { useSelector } from 'react-redux'

import { type CartControllerSellerGroupV2 } from 'types/api/cart'
import { type IState } from 'types/redux'

import VoucherDetailsModal, { type VoucherDetailsModalProps } from './'

export const VoucherDetailsModalConnected: FunctionComponent<
  VoucherDetailsModalProps
> = (props): React.ReactElement => {
  const sellers: CartControllerSellerGroupV2[] = useSelector<
    IState,
    CartControllerSellerGroupV2[]
  >((state: IState): CartControllerSellerGroupV2[] => {
    if (!state.cart.data) return []
    if (state.cart?.data?.sellerGroups) {
      return state.cart.data.sellerGroups
    }
    return []
  })

  return (
    <VoucherDetailsModal {...props} sellers={sellers} disablesOnShowModal />
  )
}
